import React, { Component, ErrorInfo, ReactNode } from "react";

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    if (error.message.includes("Invalid state")) {
        console.error("Caught 'Invalid state' error, reloading the page to re-authenticate.", error, errorInfo);
        window.location.assign(window.location.origin);
    } else {
        console.error("Uncaught error:", error, errorInfo);
    }
  }

  public render() {
    if (this.state.hasError) {
      return <h1>Something went wrong. Please wait while we try to fix it.</h1>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
